<template>
  <BaseIdCard @click="onClick" :innerClass="['p-6', isSelectecdForMultiSelect ? 'border border-green-700' : '']">
    <div class="absolute right-6 top-4 flex flex-col items-end gap-6">
      <EuroIcon v-show="showEuroIcon" />
      <EuroBarrerIcon v-show="showCrossedEuroIcon" />

      <EtatChips :etat="props.commande.etat" />
    </div>

    <div class="flex justify-between items-center">
      <div class="flex flex-col gap-1">
        <TitreDeux :content="commande.nom" />
        <BaseKeyValue :cles="t('orderBy')" v-if="isAdmin" size="text-sm">
          <SimpleText :content="props.commande.utilisateur.email" size="text-sm" />
        </BaseKeyValue>

        <SimpleText :content="dateFormatee" color="text-gray-600" size="text-sm" />
      </div>
    </div>
  </BaseIdCard>
</template>

<script setup>

import {computed, defineProps} from 'vue';
import EtatChips from "@/components/molecules/EtatChips.vue";
import {t} from "@/utils/Traduction";
import EuroIcon from "@/components/atoms/EuroIcon.vue";
import EuroBarrerIcon from "@/components/atoms/EuroBarrerIcon.vue";
import TitreDeux from "@/components/atoms/TitreDeux.vue";
import {useRouter} from "vue-router";
import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {enumeration} from "../../../Enumeration";
import BaseIdCard from "@/components/molecules/BaseIdCard.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";
import BaseKeyValue from "@/components/molecules/BaseKeyValue.vue";

const props = defineProps({
  commande: Object,
  isMultiCommandeMode: Boolean,
  toogleOrderToMultiOrderSelect: Function,
  isSelectecdForMultiSelect: Boolean
});

const utilisateurStores = UtilisateurStores();
const isAdmin = computed(() => utilisateurStores.role === enumeration.role.ADMIN);
const showEuroIcon = computed(() => !props.commande.estGratuite);
const showCrossedEuroIcon = computed(() => props.commande.estGratuite);

const router = useRouter();

let dateFormatee = '';
if(props.commande.dateDebut) {
  const dateObj = new Date(props.commande.dateDebut);

  const jour = dateObj.getUTCDate().toString().padStart(2, '0');
  const mois = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
  const annee = dateObj.getUTCFullYear();

  dateFormatee = `${jour}-${mois}-${annee}`;
}

const onClick = () => {
  if(props.isMultiCommandeMode) {
    props.toogleOrderToMultiOrderSelect(props.commande.uuid);
  } else {
    router.push('/commandes/' + props.commande.uuid);
  }
};


</script>

<style scoped>

</style>